<template>
  <a-card title="捐赠金额统计" :body-style="{ padding: 0 }">
    <div class="info-stat justify-around" style="height: 130px">
      <div class="stat-item">
        <div ref="noReview" class="stat-value text-indigo">
          <span>0</span>
          <i>笔</i>
        </div>
        <div class="stat-field">捐赠笔数</div>
      </div>
      <div class="stat-item">
        <div ref="noReply" class="stat-value text-primary">
          <span>0</span>
          <i>元</i>
        </div>
        <div class="stat-field">捐赠金额</div>
      </div>
    </div>
    <div class="flex items-center">
      <div class="col"></div>
      <div style="width: 400px">
        <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :columns="columns" :data-source="list" :scroll="{ x: '100%' }" rowKey="id"></a-table>
      </div>
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'StatProject',
  data() {
    return {
      loading: false,
      list: [],
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: 80,
          align: 'center',
          // fixed: 'left',
          customRender: (text, record, index) => index + 1,
        },
        {
          title: '月份',
          dataIndex: 'month',
          width: 120,
          // fixed: 'left',
          scopedSlots: { customRender: 'month' },
        },
        {
          title: '当月捐赠金额合计',
          ellipsis: true,
          dataIndex: 'curMonth',
          width: 250,
          // fixed: 'left',
          scopedSlots: { customRender: 'curMonth' },
        },
        {
          title: '今年以来捐赠金额合计',
          ellipsis: true,
          dataIndex: 'curYear',
          width: 250,
          // fixed: 'left',
          scopedSlots: { customRender: 'curYear' },
        },
      ],
    }
  },
  methods: {
    init() {},
  },
  mounted() {
    this.init()
  },
}
</script>
